<template>
  <div class="app-container">
    <list ref="list" @deleted="reload">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <!-- <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button> -->
        <el-button type="primary" @click="createTree" icon="el-icon-plus"
          >添加</el-button
        >
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column">
        <!-- <el-table-column label="操作" fixed="right" align="center" width="60"> -->
        <el-table-column label="操作" fixed="right" align="center" width="190">
          <template slot-scope="{ row }">
            <el-button
              v-if="$permission.canRead()"
              type="text"
              @click="edit(row)"
              >查看</el-button
            >
            <el-button
              v-if="$permission.canWrite()"
              type="text"
              @click="toTree(row)"
              >结构图</el-button
            >
            <el-button
              v-if="$permission.canWrite()"
              type="text"
              @click="onExport(row)"
              >导出</el-button
            >
            <el-button
              v-if="$permission.canWrite()"
              type="text"
              @click="copy(row)"
              >复制</el-button
            >
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog"></edit-dialog>
    <export-dialog ref="exportDialog"></export-dialog>
    <bom-dialog ref="bomDialog" @confirm="toCopy"></bom-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/production/craftsmanship/bom/list";
import editDialog from "@/components/production/craftsmanship/bom/editDialog";
import exportDialog from "@/components/production/craftsmanship/bom/exportDialog";
import bomDialog from "./bomDialog";

export default {
  name: "bom",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    exportDialog,
    bomDialog,
  },
  data() {
    return {
      api: require("@/api/production/teProduct").default,
      row: {},
    };
  },
  methods: {
    delRows() {
      this.$refs.list.del();
    },
    create() {
      this.$router.push({
        name: "editbom",
        params: {
          type: 0,
          TeProductId: 0,
        },
      });
    },
    edit({ TeProductId }) {
      console.log("TeProductId", TeProductId);

      this.api.getInfoV2(TeProductId).then((res) => {
        if (res.Code === 0) {
          this.$router.push({
            name: "editbom",
            params: {
              data: res.Data,
              TeProductId: TeProductId,
            },
          });
        }
      });
    },
    toTree(row) {
      // console.log("toTree", row);
      this.$router.push({
        name: "treechart",
        params: {
          TeProductId: row.TeProductId,
        },
      });
    },
    createTree() {
      // console.log("toTree", row);
      this.$router.push({
        name: "treechartList",
        params: {
          HasChaild: true,
        },
      });
    },
    onExport(row) {
      console.log(this.$refs);
      this.$refs.exportDialog.getData(row.TeProductId);
      this.$refs.exportDialog.open();
      //this.$confirm("是否导出数据？", "提示", {
      //confirmButtonText: "确定",
      //cancelButtonText: "取消",
      //type: "warning",
      //})
      //.then(() => {
      //var params = { Id:row.TeProductId };

      //var loading = this.$loading({
      // lock: true,
      //  text: "正在导出...",
      //  spinner: "el-icon-loading",
      //customClass: "my_loading",
      //background: "rgba(0, 0, 0, 0.3)",
      //});
      //this.api.bomInfoExport(params).then(res => {
      //loading.close();
      //})
      //})
      //.catch(() => {});
    },
    copy(row) {
      this.row = row;
      this.$refs.bomDialog.open();
    },
    toCopy(data) {
      var loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.copy({ TeProductId: this.row.TeProductId, Bomno: data.Bomno }).then((res) => {
        loading.close();
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.reload();
          this.toTree({TeProductId: res.Data});
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
